export const Transfers = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0002 0H9.86392V9.76744L4.13672 14H6.68214L14.0002 9.76744V0Z"
      fill="currentColor"
    />
    <path
      d="M-0.00023365 14L4.13608 14L4.13608 4.23256L9.86328 1.90735e-06L7.31786 2.13505e-06L-0.000234485 4.23256L-0.00023365 14Z"
      fill="currentColor"
    />
  </svg>
);
